import { render, staticRenderFns } from "./ReportCases.vue?vue&type=template&id=4c8b8ca2"
import script from "./ReportCases.vue?vue&type=script&lang=js"
export * from "./ReportCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports